import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { useIntervalArray } from '@/composables/useIntervalArray'
import {
  NEXT_LESSONS_FETCH_INTERVAL,
  NEXT_LESSONS_INTERVAL
} from '@/constants/times'
import { httpService } from '@/service/http.service'
import type { NextUp } from '@/types'

export const useNextUpsStore = defineStore('nextUps', () => {
  const nextUps = ref<NextUp[]>([])
  const CHUNK_SIZE = 8
  const currentIndex = ref(0)

  const { start: startSlider } = useIntervalArray(
    [NEXT_LESSONS_INTERVAL],
    nextPackageOfNextUps
  )

  const chunkedNextUps = computed<NextUp[][]>(() => {
    const chunks = []
    for (let i = 0; i < nextUps.value.length; i += CHUNK_SIZE) {
      chunks.push(nextUps.value.slice(i, i + CHUNK_SIZE))
    }
    return chunks
  })

  function nextPackageOfNextUps() {
    if (chunkedNextUps.value.length > 0)
      currentIndex.value =
        (currentIndex.value + 1) % chunkedNextUps.value.length
  }

  const currentNextUps = computed<NextUp[]>(
    () => chunkedNextUps.value[currentIndex.value] || []
  )

  const { start } = useIntervalArray(
    [NEXT_LESSONS_FETCH_INTERVAL],
    fetchNextUps
  )

  async function fetchNextUps() {
    try {
      const responseData =
        await httpService.infoboards.infoboardsPublicNextLessonsList({
          page_size: 99999
        })
      nextUps.value = responseData.results || []
    } catch {
      // console.log(err)
    }
  }

  function bootstrapNextUps() {
    fetchNextUps()
    start()
    startSlider()
  }

  return {
    currentNextUps,
    bootstrapNextUps
  }
})
